import { useAuth0 } from "@auth0/auth0-react"
import { useContext, useEffect, useMemo } from "react"

import { hasFeatureInPackage, isAdmin, isSuperAdminOrResellerAdmin, isSuperAdminOrResellerAdminOrAdmin } from "../../../../../../Utils/util"

import { useLocation, useParams } from "react-router-dom"
import DeviceStructure from "../../../../../../Components/BifrostDeviceStructureComponent/template/DeviceStructure"
import BifrostTab from "../../../../../../Components/BifrostElementComponent/BifrostTab/BifrostTab"
import Loader from "../../../../../../Components/BifrostPageComponent/Loader/Loader"
import BifrostEventComponent from "../../../../../../Components/BifrostPageComponent/OrganizationComponents/BifrostEventComponent"
import BifrostSessionComponent from "../../../../../../Components/BifrostPageComponent/OrganizationComponents/BifrostSessionComponent"
import OrgDetailsComponent from "../../../../../../Components/BifrostPageComponent/OrganizationComponents/OrgDetailsComponent"
import { useGetOrganizationByID } from "../../../../../../Hooks/FetchHooks/GetDataService/useGetOrganizationByID"
import { ReactComponent as DevicesIcon } from "../../../../../../Icons/devices-icon.svg"
import userInfoContext from "../../../../../../store/userInfoContext"
import Error401 from "../../../../../OtherPages/ErrorPage/Error401"
import MainPanelHeader from "../../../../MainPanelHeader/MainPanelHeader"

const OrganizationView = () => {
	const { id } = useParams()
	const { state } = useLocation()
	const userInfo = useContext(userInfoContext)
	const { user } = useAuth0()
	const { isLoading, isError, data, getOrganizationByID } = useGetOrganizationByID(isAdmin(user) ? userInfo.org.id : id)

	const detailData = useMemo(() => {
		return [
			{
				tabName: "Details",
				feature: null,
				featureName: null,
				featureIcon: null,
				renderCondition: process.env.REACT_APP_SAML_ENABLED === "true",
				disabled: false,
				tabContent: <OrgDetailsComponent chosenOrg={data} refreshData={getOrganizationByID} orgDetailsLoading={isLoading} />
			},
			{
				tabName: "Events",
				feature: hasFeatureInPackage(userInfo, "audit_log"),
				featureName: "audit_log",
				featureIcon: "calendar checked",
				disabled: !isSuperAdminOrResellerAdminOrAdmin(user),
				tabContent: <BifrostEventComponent chosenItem={data} chosenItemType="org" />
			},
			{
				tabName: "Sessions",
				feature: hasFeatureInPackage(userInfo, "statistics"),
				featureName: "statistics",
				featureIcon: "list",
				disabled: !isSuperAdminOrResellerAdminOrAdmin(user),
				tabContent: <BifrostSessionComponent chosenItem={data} chosenItemType="org" />
			},
			{
				tabName: "Devices",
				feature: null,
				featureName: null,
				icon: <DevicesIcon className="icon-align" style={{ marginRight: "5px" }} />,
				renderCondition: process.env.REACT_APP_SAML_ENABLED === "true" || !isSuperAdminOrResellerAdmin(user),
				disabled: !isSuperAdminOrResellerAdminOrAdmin(user),
				tabContent: <DeviceStructure />
			}
		]
	}, [data, isLoading])

	const style = {
		tabular: true,
		tabStyle: { paddingTop: "10px" },
		contentStyle: { padding: "20px" }
	}

	const handleSetActiveTab = (setActiveItem) => {
		if (state && state.tab) {
			setActiveItem(state.tab)
		} else {
			setActiveItem("Details")
		}
	}

	useEffect(() => {
		userInfo && userInfo.terms_accepted && getOrganizationByID()
	}, [id, userInfo])

	return (
		<section className={"bifrost-table-panel users-table"}>
			<MainPanelHeader title={isAdmin(user) ? userInfo.org.name : null} name={isLoading ? (state ? state.name : "") : data.name} fetchData={getOrganizationByID} navPath={"/orgs"} />
			{isLoading ? (
				<Loader backgroundColor="white" inverted height="1px" minHeight="200px" />
			) : (
				<>{isError ? <Error401 backgroundColor="white" /> : <BifrostTab detailData={detailData} style={style} setActiveTab={handleSetActiveTab} />}</>
			)}
			<section className="bifrost-table-panel-footer" />
		</section>
	)
}

export default OrganizationView
